import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import Form from "./components/Form.vue";
import DistributionGroupService from "@/clinic/services/distribution_group_service";
import { ref, onBeforeMount } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";

export default /*#__PURE__*/_defineComponent({
  __name: 'Duplicate',
  setup(__props) {

const isFetchFinished = ref(false);
const clinicId = ref();
const router = useRouter();
const store = useStore();
const deliverySetting = ref({});
const basicInformation = ref({});
const messageSetting = ref();
const targetInformation = ref({});
const fetchDistributionGroup = async () => {
  const { id } = router.currentRoute.value.params;
  const params = { clinic_id: clinicId.value };
  const response = await DistributionGroupService.getDistributionGroup(id, params);
  basicInformation.value = response.data.value.basic_setting;
  messageSetting.value = response.data.value.message_setting.group_messages;
  targetInformation.value = response.data.value.target_setting;
  deliverySetting.value = response.data.value.delivery_setting;
  isFetchFinished.value = true;
};
const loadClinicInfo = async () => {
  const storeClinicId = await store.dispatch("authClient/getClinicIdCookie");
  clinicId.value = storeClinicId;
};
onBeforeMount(async () => {
  await loadClinicInfo();
  await fetchDistributionGroup();
});

return (_ctx: any,_cache: any) => {
  return (isFetchFinished.value)
    ? (_openBlock(), _createBlock(Form, {
        key: 0,
        basicInformation: basicInformation.value,
        messageSetting: messageSetting.value,
        targetInformation: targetInformation.value,
        deliverySetting: deliverySetting.value
      }, null, 8, ["basicInformation", "messageSetting", "targetInformation", "deliverySetting"]))
    : _createCommentVNode("", true)
}
}

})